var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.947,
    height: 17.578,
    viewBox: "0 0 19.947 17.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-wallet",
    "data-name": "Icon awesome-wallet",
    d: "M17.067,5.8H2.96a.592.592,0,1,1,0-1.184H17.17a.592.592,0,0,0,.592-.592A1.776,1.776,0,0,0,15.986,2.25H2.368A2.368,2.368,0,0,0,0,4.618V16.46a2.368,2.368,0,0,0,2.368,2.368h14.7a1.832,1.832,0,0,0,1.88-1.776V7.579A1.832,1.832,0,0,0,17.067,5.8Zm-1.673,7.7a1.184,1.184,0,1,1,1.184-1.184A1.184,1.184,0,0,1,15.394,13.5Z",
    transform: "translate(0.5 -1.75)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.bfe8859bafa197a561786844155632b5.svg";
export { ForwardRef as ReactComponent };